import type { MfrrMarket } from 'api/mfrr/mfrr.types'
import { useEffect } from 'react'
import mfrrStore from 'store/mfrr/mfrr'
import { getMfrrDeliveryWindowEnd } from '../../components/MRFFCMTrading/MFRRCMTrading.helper'

export function useViewedMfrrBidWindow(market: MfrrMarket | null, startTime: ISODateTime): void {
  useEffect(() => {
    if (!market) {
      mfrrStore.viewedBidWindow = undefined
      return
    }

    mfrrStore.viewedBidWindow = { market, startTime, endTime: getMfrrDeliveryWindowEnd(startTime) }

    return () => {
      mfrrStore.viewedBidWindow = undefined
    }
  }, [market, startTime])
}
